<template lang="html">
  <div :class="['chk-wrapper', disabled && 'disabled']">
     <label :for="id" class="text">
      <input
        type="checkbox"
        class="checkbox"
        :id="id"
        @input="(event) => onChange(event.target.checked)"
        :value="value"
      />
      <span class="chk-mask"></span>
    {{ text }}
   </label>
  </div>
</template>
<script>
export default {
  props: {
    id: String,
    text: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    value: String,
    onChange: Function,
  },
};
</script>
<style lang="css" scoped>
.chk-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.chk-wrapper .checkbox {
  display: none;
  position: absolute;
}
.chk-wrapper:hover .chk-mask {
  border: 2px solid rgba(51, 100, 126, 0.8);
}
.chk-wrapper.disabled .chk-mask {
  border: 2px solid #acacac !important;
}
.chk-wrapper.disabled .checkbox:checked + .chk-mask::after {
  background: #acacac !important;
}
.chk-wrapper.disabled .text {
  color: #acacac !important;
}
.chk-wrapper .chk-mask {
  width: 25px;
  height: 25px;
  border: 2px solid #33647e;
  box-sizing: border-box;
  border-radius: 6px;
  position: absolute;
  cursor: pointer;
  margin-left: -30px;
}
.chk-wrapper.disabled .chk-mask {
  cursor: not-allowed;
}

.chk-wrapper .checkbox:checked + .chk-mask::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 49%;
  transform: translate(-50%, -50%);
  width: 17px;
  height: 17px;
  border-radius: 5px;
  background: #33647e;
}
.chk-wrapper .text {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 23px;
  color: #013652;
  margin-left: 30px;
  cursor: pointer;
}
.chk-wrapper.disabled .text {
  cursor: not-allowed;
}
</style>
